import React from 'react';
import PropTypes from 'prop-types';
import RadioButtonList from './radioButtonList';

export default class GroupedRadioButtonList extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        let successState = null;
        if (this.props.isValid !== null && this.props.isValid !== undefined) {
            if (this.props.isValid) {
                successState = "is-valid";
            }
            else {
                successState = "is-invalid";
            }
        }
        let grouping = [];
        let i = 0;
        while (i < this.props.groupedOptions.length) {
            grouping.push(
                <div key={"option" + i} className="custom-radio-grouping">
                    <RadioButtonList
                        invalidFeedback=""
                        name={this.props.groupedOptions[i].name}
                        onChange={this.props.onChange}
                        options={this.props.groupedOptions[i].options}
                        label={this.props.groupedOptions[i].groupingHeader}
                        value={this.props.value} />
                </div>
            );
            i++;
        }
        return (
            <div className={this.props.className ? "radio-list " + this.props.className : "radio-list"}>
                <label htmlFor={this.props.id}>
                    {this.props.label}
                </label>
                <div className={successState ? "radio-buttons " + successState : "radio-buttons"}>
                    {grouping}
                </div>
                <div className="invalid-feedback">
                    {this.props.invalidFeedback}
                </div>
            </div>
        );
    }
}

GroupedRadioButtonList.propTypes = {
    groupedOptions: PropTypes.arrayOf(PropTypes.shape({
        groupingHeader: PropTypes.string,
        name: PropTypes.string,
        options: PropTypes.arrayOf(PropTypes.shape({
            id: PropTypes.string,
            text: PropTypes.string,
            value: PropTypes.string
        }))
    })).isRequired
};